
import { Vue } from "vue-class-component";

export default class PickupAgentHub extends Vue {}
